package com.damda.design_system.ui.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.damda.design_system.ui.viewmodels.FoodCartState
import com.damda.design_system.ui.views.compose_migrations.layouts.AppBar
import com.damda.design_system.ui.views.compose_migrations.layouts.JSSpacer
import com.damda.design_system.ui.views.compose_migrations.layouts.WidthFullSizeButton
import com.damda.design_system.ui.views.core.ComposeWindowWidthSizeClass
import com.damda.design_system.ui.views.food_carts.FoodCartList
import kotlinx.browser.window
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Text

@Composable
fun FoodCartScreen(
    windowSize: ComposeWindowWidthSizeClass,
    cartState: FoodCartState = FoodCartState(),
    onBackArrowClick: () -> Unit
) {
    var resizeFontSize by remember { mutableStateOf(0.px) }

    val newFontSize = when (windowSize) {
        ComposeWindowWidthSizeClass.Small -> 4.px
        ComposeWindowWidthSizeClass.Medium -> 2.px
        ComposeWindowWidthSizeClass.Large -> 0.px
        else -> {
            0.px
        }
    }
    resizeFontSize = newFontSize

    Div(
        attrs = {
            style {
                width(100.percent)
                height(100.percent)
                overflowY("scroll")
            }
        }
    ) {
        JSSpacer(height = 12.px)
        AppBar("Food Cart") { onBackArrowClick() }
        JSSpacer(height = 12.px)


        if (cartState.cartCount == 0) {
            EmptyCartList()
        } else {
            FulledCartList(cartState, resizeFontSize, windowSize)
        }

        Div(attrs = {
            style {
                height(24.px)
            }
        })
    }
}

@Composable
fun EmptyCartList() {
    Div (
        attrs = {
            style {
                width(100.percent)
                height(100.percent - 72.px)
                minHeight(400.px)
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center)
            }
        }
    ){
        Text("장바구니에 상품을 담지 않았습니다.")
    }
}

@Composable
fun FulledCartList(
    cartState: FoodCartState,
    resizeFontSize: CSSSizeValue<CSSUnit.px> = 0.px,
    windowSize: ComposeWindowWidthSizeClass
) {
    Div(
        attrs = {
            style {
                minHeight(400.px)
            }
        }
    ) { FoodCartList(cartState, resizeFontSize) }
    Div(
        attrs = {
            style {
                padding(24.px)
            }
        }
    ) {
        WidthFullSizeButton(
            title = "주문하기",
            reduceFontSize = resizeFontSize,
            onClick = {
                sendMessage(cartState, windowSize)
            }
        )
    }
}

fun sendMessage(cartState: FoodCartState, windowSize: ComposeWindowWidthSizeClass) {
    if (windowSize == ComposeWindowWidthSizeClass.Small || windowSize == ComposeWindowWidthSizeClass.Medium) {
        var receipt = "메뉴:"
        cartState.cartItems.forEach { item ->
            receipt += "-" + item.key.title + " 메뉴를 " + item.value + "개 주문\n"
            console.log(receipt)
        }
        receipt += "주문하려고 합니다.\n방문하는 일자와 인원수를 함께 기재해주시면 예약 편하게 도와드리겠습니다."

        window.location.href = "sms:01049263150?body=${encodeURIComponent(receipt)}"
    } else {
        cartState.showNotPhoneDialogEvent()
    }
}

fun encodeURIComponent(s: String): String {
    return js("encodeURIComponent")(s) as String
}